import { jsx as _jsx } from "react/jsx-runtime";
import { ListChecks, OctagonAlert, FileEdit, Building2, Activity, Settings, AlertTriangle, CheckCircle2, SearchX, Eye, EyeOff, Copy, Check, Download, ChevronDown, ChevronUp, ExternalLink, BarChart2, MessageSquare, Search, X, Plus, } from "lucide-react";
const ICON_MAP = {
    "list-checks": ListChecks,
    "octagon-alert": OctagonAlert,
    "file-edit": FileEdit,
    "building-2": Building2,
    "activity": Activity,
    "settings": Settings,
    "alert-triangle": AlertTriangle,
    "check-circle-2": CheckCircle2,
    "search-x": SearchX,
    "eye": Eye,
    "eye-off": EyeOff,
    "copy": Copy,
    "check": Check,
    "download": Download,
    "chevron-down": ChevronDown,
    "chevron-up": ChevronUp,
    "external-link": ExternalLink,
    "bar-chart-2": BarChart2,
    // Phase 408 wave 3 task 3.1 — the console chat surface (ADR-089). The ICON_MAP is a
    // CLOSED vocabulary (IconName is `keyof typeof`), so a new surface needs its glyph
    // admitted here before any screen can name it.
    "message-square": MessageSquare,
    // Walk 4 (#2267/#2268) — the onboarding board's search, and the look-through dialog's close and
    // "add a person" controls.
    "search": Search,
    "x": X,
    "plus": Plus,
};
export default function Icon({ name, size = 14, ...rest }) {
    const Component = ICON_MAP[name];
    return (_jsx("span", { className: "ic", style: { display: "inline-flex", width: size, height: size }, ...rest, children: _jsx(Component, { size: size, strokeWidth: 2 }) }));
}
//# sourceMappingURL=Icon.js.map